import React from "react"
import PropTypes from "prop-types"
import {
  rendezVousTitle,
  rendezVousSubContainerWithStep,
} from "../Part3/rendez-vous-part-3.module.scss"
import {
  rendezVousCheckbox,
  rendezVousChoiceTypeContainer,
  rendezVousPart4Container,
  rendezVousPart4FormContainer,
  rendezVousPart4CaseCochable,
  checkIcon,
  spanContainer,
} from "./rendez-vous-part-4.module.scss"
import {
  RendezVousSubContainer,
  RendezVousTitle,
  RendezVousPart4Input,
  RendezVousPart4TextArea,
  RendezVousInputType,
} from "../rendez-vous-styled.js"
import { StepIndicator } from "../StepIndicator/step-indicator"

export const RendezVousPart4 = ({
  contactInfo,
  setContactInfo,
  commentairePossible,
  casesCochables,
  step,
  stepRefs,
}) => {
  const handleChange = (event) => {
    setContactInfo({ ...contactInfo, [event.target.name]: event.target.value })
  }

  const handleCheckbox = (event) => {
    const index = event.target.getAttribute("data-index")
    const cases = contactInfo.cases
    cases[index] = event.target.checked
    setContactInfo({ ...contactInfo, cases: cases })
  }

  return (
    <RendezVousSubContainer className={rendezVousSubContainerWithStep}>
      <StepIndicator step={step} refs={stepRefs} />
      <RendezVousTitle className={rendezVousTitle}>
        Informations de contact
      </RendezVousTitle>
      <div className={rendezVousPart4Container}>
        <p>
          Pour la gestion de votre rendez-vous, nous avons besoin de vos
          informations de contact. Veuillez bien remplir les champs ci-dessous
          (tous les champs marqués d&apos;une * sont obligatoires).
        </p>
        <div className={rendezVousPart4FormContainer}>
          <form>
            <label htmlFor="prenom">
              Prénom*
              <RendezVousPart4Input
                type="text"
                id="prenom"
                name="prenom"
                autoComplete="given-name"
                onChange={handleChange}
                value={contactInfo.prenom}
                required={true}
              />
            </label>
            <label htmlFor="nom">
              Nom*
              <RendezVousPart4Input
                type="text"
                id="nom"
                name="nom"
                autoComplete="family-name"
                onChange={handleChange}
                value={contactInfo.nom}
                required={true}
              />
            </label>
            <label htmlFor="phone">
              Téléphone*
              <RendezVousPart4Input
                type="tel"
                id="phone"
                name="phone"
                autoComplete={"tel"}
                onChange={handleChange}
                value={contactInfo.phone}
                required
              />
            </label>
            <label htmlFor="mail">
              E-mail
              <RendezVousPart4Input
                type="email"
                id="mail"
                name="mail"
                autoComplete={"email"}
                value={contactInfo.mail}
                onChange={handleChange}
              />
            </label>
            {commentairePossible && (
              <label htmlFor="comm">
                Commentaire
                <RendezVousPart4TextArea
                  type="text"
                  rows={10}
                  id="comm"
                  name="comm"
                  value={contactInfo.comm}
                  onChange={handleChange}
                />
              </label>
            )}
            {casesCochables && (
              <div
                className={rendezVousChoiceTypeContainer}
                role={"group"}
                aria-label={"Options supplémentaires"}
              >
                {casesCochables.map((caseCochable, index) => (
                  <div key={index}>
                    <label
                      className={rendezVousPart4CaseCochable}
                      htmlFor={"case" + index}
                    >
                      <RendezVousInputType
                        type="checkbox"
                        className={rendezVousCheckbox}
                        name={"case" + index}
                        id={"case" + index}
                        checked={contactInfo.cases[index]}
                        onChange={handleCheckbox}
                        data-index={index}
                      />{" "}
                      <div className={spanContainer}>
                        <span className={checkIcon} aria-hidden={true}></span>
                        <span>{caseCochable.value}</span>
                      </div>
                    </label>
                  </div>
                ))}
              </div>
            )}
          </form>
        </div>
      </div>
    </RendezVousSubContainer>
  )
}

RendezVousPart4.propTypes = {
  contactInfo: PropTypes.object,
  setContactInfo: PropTypes.func,
  commentairePossible: PropTypes.bool,
  casesCochables: PropTypes.array,
  step: PropTypes.number,
  stepRefs: PropTypes.arrayOf(PropTypes.shape({ current: PropTypes.any })),
}
